import { T } from "../../app/tokens.js";

export function CarouselArrowButton({
  direction,
  enabled,
  testId,
  label,
  onClick,
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={label}
      onClick={onClick}
      disabled={!enabled}
      style={{
        border: "1px solid var(--v2-line)",
        background: "var(--v2-card)",
        borderRadius: 8,
        width: 28,
        height: 28,
        cursor: enabled ? "pointer" : "default",
        color: enabled ? "var(--v2-dark)" : "var(--v2-light)",
        display: "grid",
        placeItems: "center",
        fontSize: T.fsLg,
        lineHeight: 1,
        opacity: enabled ? 1 : 0.4,
        transition: "opacity .15s",
      }}
    >
      <span aria-hidden="true">{direction === "previous" ? "‹" : "›"}</span>
    </button>
  );
}